/**
 * Private Route Component for Mobile
 * Wrapper for protecting specific routes
 */

import type { FC, ReactNode } from 'react';
import AuthGuard from './AuthGuard';

interface PrivateRouteProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children, fallback }) => {
  return (
    <AuthGuard requireAuth={true} fallback={fallback}>
      {children}
    </AuthGuard>
  );
};

export default PrivateRoute;